import { UserCustomerTypeEnum } from '@/gen/ecom-asm'
import { getAsmSession } from '@/helpers/getAsmSession'

import type { Session } from 'next-auth'

const isEmployee = (session?: Session | null) =>
  session?.user?.customerType === UserCustomerTypeEnum.Employee.toLocaleLowerCase()

/** The impersonated customer's type while an ASM employee impersonates someone, otherwise undefined. */
export function getImpersonatedCustomerType(
  session?: Session | null,
  serverCookies?: string
): UserCustomerTypeEnum | undefined {
  if (!isEmployee(session)) {
    return undefined
  }

  return getAsmSession(serverCookies)?.impersonatedUser?.customerType
}

export function getCustomerType(session?: Session | null, serverCookies?: string): UserCustomerTypeEnum {
  return (
    getImpersonatedCustomerType(session, serverCookies) ?? session?.user?.customerType ?? UserCustomerTypeEnum.Guest
  )
}
